module.exports = "<div class=\"m-getfeatureinfo-content\">\n   {{{info}}}\n</div>";